import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';


const fieldId = 'manufacturer';

// This is only ever used as a read only field and so we never want to validate it
const validator = () => null;


const initialValues = '';

const vFParams = {
  fieldTitle: 'Manufacturer',
  placeholder: '',
};


const manufacturer = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { manufacturer };
